import { useEffect } from 'react';
import { useAppDispatch, useAppState } from '@/store';
import {
  getConversationChannelTheme,
  selectConversationChannelTheme,
  selectConversationChannelThemeIsLoading,
} from '../feature';

export const useGetConversationChannelTheme = (channelSlug?: string) => {
  const dispatch = useAppDispatch();
  const theme = useAppState(selectConversationChannelTheme);
  const isLoading = useAppState(selectConversationChannelThemeIsLoading);

  useEffect(() => {
    if (!channelSlug) return;
    dispatch(getConversationChannelTheme({ channel: channelSlug }));
  }, [channelSlug, dispatch]);

  return { theme, isLoading };
};
